import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

@Component({
  selector: 'asax-frequency-view',
  template: `
    <asax-frequency-view-frequency-view-chart-container [height]="height"
                                                        [width]="width">
    </asax-frequency-view-frequency-view-chart-container>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AsaxFrequencyViewComponent {
  @Input() height: number;
  @Input() width: number;
}
